import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// This component ensures that every time a user navigates to a new page,
// the window scrolls to the very top.
const ScrollToTop = () => {
  // useLocation() returns the location object that represents the current URL.
  const { pathname } = useLocation();

  // This useEffect hook will run every time the 'pathname' (the URL path) changes.
  useEffect(() => {
    // This command scrolls the window to the top left corner (coordinates 0, 0).
    window.scrollTo(0, 0);
  }, [pathname]); // The effect depends on the pathname, so it re-runs on navigation.

  // This component doesn't render anything itself, it just performs an action.
  return null;
};

export default ScrollToTop;
